import React from 'react';
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { ThemeProvider, createTheme } from "@mui/material/styles";

const theme = createTheme();

interface DateRangeSelectorProps {
  startDate: any;
  endDate: any;
  onStartDateChange: (date: any) => void;
  onEndDateChange: (date: any) => void;
  onClear: () => void;
}

const DateRangeSelector: React.FC<DateRangeSelectorProps> = ({
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  onClear,
}) => {
  const slotProps = {
    desktopPaper: {
      sx: {
        mt: 1.25,
        transform: "translateX(calc(0% - 30px))",
        borderRadius: "12px",
        border: "1px solid #323C48",
        boxShadow: "box-shadow: 0 4px 24px #CBD5E066",
        "& .Mui-selected": {
          backgroundColor: "#407097 !important",
          color: "#FFFFFF !important",
        },
      },
    },
    textField: {
      placeholder: "Date Range",
      sx: {
        width: "fit-content",
        "& .MuiInputLabel-root": {
          display: "none",
        },
        "& .MuiOutlinedInput-root": {
          fontFamily: "Inter, sans-serif",
          fontSize: "14px",
          fontWeight: "600",
          color: "#222830",
          height: "40px",
          borderRadius: "24px",
          backgroundColor: "#F3F5F7",
          display: "flex",
          alignItems: "center",
          "&:hover": {
            borderColor: "#407097",
          },
          "&.Mui-focused": {
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "#407097",
              borderWidth: "2px",
            },
          },
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#C3CBD5",
          },
        },
        "& .MuiInputBase-input": {
          padding: "0 12px",
          "&::placeholder": {
            color: "#323C48",
            opacity: 1,
          },
        },
        "& .MuiSvgIcon-root": {
          color: "#323C48",
        },
      },
    },
  };

  return (
    <div className="flex items-center gap-2">
      <ThemeProvider theme={theme}>
        <LocalizationProvider
          dateAdapter={AdapterDayjs}
          adapterLocale="en"
        >
          <DatePicker
            views={["year", "month"]}
            value={startDate}
            onChange={onStartDateChange}
            slotProps={slotProps}
          />
          <span className="text-gray-500 text-sm">to</span>
          <DatePicker
            views={["year", "month"]}
            value={endDate}
            onChange={onEndDateChange}
            slotProps={slotProps}
          />
        </LocalizationProvider>
      </ThemeProvider>
      {(startDate || endDate) && (
        <button
          onClick={onClear}
          className="px-3 py-2 text-sm text-gray-600 hover:text-gray-800 hover:bg-gray-100 rounded-lg transition-colors"
        >
          Clear
        </button>
      )}
    </div>
  );
};

export default DateRangeSelector; 